import React from "react";
import Product from "../../../../utilities/data/model/Product";

export type SelectedProductType = {
  product?: Product;
  setProduct: (product: Product | undefined) => void;
};

export const SelectedProductContext = React.createContext<
  SelectedProductType | undefined
>(undefined);
